// extracted by mini-css-extract-plugin
module.exports = {"articleGrid":"ArticleGrid_articleGrid__5O03Q"};